<template v-slot:default="{ hide }">

    <div class="px-3 py-2">
        <div v-for="(row1, index) in company_options" :key="index">
            <div v-if="row1.options.length == 0 && default_column.includes(row1.label)">
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="list"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" :placeholder="stringView(row1.label)" :name="row1.label"
                        v-model="search_by_filter[row1.label]"></b-form-input>
                </b-input-group>
            </div>
        </div>
        <div v-for="(row2, index2) in company_options" :key="row2.label">
            <div v-if="row2.options.length > 0 && default_column.includes(row2.label)">
                <div v-if="filter_by_id.includes(row2.label) && row2.label == 'leave_type'">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <!-- <div class="form-control p-0" v-if="search_by_filter['leave_policy_id'] == ''">
                            <select name="Select Leave Type" class='form-control'
                                v-model="search_by_filter['leave_type_id']">
                                <option value=''>Select Leave Type </option>
                                <option v-for='data in row2.options' :value='data.id'
                                    :key="data.id + data.name + data.name">{{ data.name }}</option>
                            </select>
                        </div> -->

                        <select v-if="search_by_filter['leave_policy_id'] == ''" name="Select Leave Type"
                            class='form-control' v-model="search_by_filter['leave_type_id']">
                            <option value=''>Select Leave Type </option>
                            <option v-for='data in row2.options' :value='data.id'
                                :key="data.id + data.name + data.name">{{
                                    data.name }}</option>
                        </select>
                        <!-- <div v-else class="form-control p-0">
                            <select name="Select Leave Type" class='form-control'
                                v-model="search_by_filter['leave_type_id']">
                                <option value=''>Select Leave Type </option>
                                <option v-for='data in row2.options' :value='data.id'
                                    :key="data.id + data.id + data.name + data.name"
                                    v-if="leave_type_arr[search_by_filter['leave_policy_id']].includes(data.id)">{{
                                    data.name }}</option>
                            </select>
                        </div> -->

                        <select v-else name="Select Leave Type" class='form-control'
                            v-model="search_by_filter['leave_type_id']">
                            <option value=''>Select Leave Type </option>
                            <option v-for='data in row2.options' :value='data.id'
                                :key="data.id + data.id + data.name + data.name"
                                v-if="leave_type_arr[search_by_filter['leave_policy_id']].includes(data.id)">{{
                                    data.name }}</option>
                        </select>
                    </b-input-group>
                </div>
                <div v-else-if="filter_by_id.includes(row2.label)">

                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select :name="row2.label" class='form-control' v-model="search_by_filter[row2.label + '_id']">
                            <option value=''>Select {{ stringView(row2.label) }}</option>
                            <option v-for='data in row2.options' :value='data.id' :key="data.id + data.name">{{ data.name
                                }}</option>
                        </select>
                    </b-input-group>
                </div>
                <div v-else>
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select :name="row2.label" class='form-control' v-model='search_by_filter[row2.label]'>
                            <option value=''>Select {{ stringView(row2.label) }}</option>
                            <option v-for='data in row2.options' :value='data.id' :key="data.id + data.name">{{ data.name
                                }}</option>
                        </select>
                    </b-input-group>
                </div>
            </div>
        </div>
        <div v-for="(row3, index4) in company_options" :key="row3.label + index4">
            <div v-if="row3.options.length == 0 && column_selected.includes(row3.label)">
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="list"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" :placeholder="stringView(row3.label)" :name="row3.label"
                        v-model="search_by_filter[row3.label]"></b-form-input>
                </b-input-group>
            </div>
        </div>
        <div v-for="(row4, index3) in company_options" :key="index3 + row4.label">
            <div v-if="row4.options.length > 0 && column_selected.includes(row4.label)">
                <div v-if="filter_by_id.includes(row4.label) && row4.label == 'leave_type'">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <!-- <div class="form-control p-0" v-if="search_by_filter['leave_policy_id'] == ''">
                            <select name="Select Leave Type" class='form-control'
                                v-model="search_by_filter['leave_type_id']">
                                <option value=''>Select Leave Type </option>
                                <option v-for='data in row4.options' :value='data.id'
                                    :key="data.id + data.name + data.name">{{ data.name }}</option>
                            </select>
                        </div> -->

                        <select v-if="search_by_filter['leave_policy_id'] == ''" name="Select Leave Type"
                            class='form-control' v-model="search_by_filter['leave_type_id']">
                            <option value=''>Select Leave Type </option>
                            <option v-for='data in row4.options' :value='data.id'
                                :key="data.id + data.name + data.name">{{
                                    data.name }}</option>
                        </select>
                        <!-- <div v-else class="form-control p-0">
                            <select name="Select Leave Type" class='form-control'
                                v-model="search_by_filter['leave_type_id']">
                                <option value=''>Select Leave Type </option>
                                <option v-for='data in row4.options' :value='data.id'
                                    :key="data.id + data.id + data.name + data.name"
                                    v-if="leave_type_arr[search_by_filter['leave_policy_id']].includes(data.id)">{{
                                    data.name }}</option>
                            </select>
                        </div> -->

                        <select v-else name="Select Leave Type" class='form-control'
                            v-model="search_by_filter['leave_type_id']">
                            <option value=''>Select Leave Type </option>
                            <option v-for='data in row4.options' :value='data.id'
                                :key="data.id + data.id + data.name + data.name"
                                v-if="leave_type_arr[search_by_filter['leave_policy_id']].includes(data.id)">{{
                                    data.name }}</option>
                        </select>
                    </b-input-group>
                </div>
                <div v-else-if="filter_by_id.includes(row4.label)">

                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select :name="row4.label" class='form-control' v-model="search_by_filter[row4.label + '_id']">
                            <option value=''>Select {{ stringView(row4.label) }}</option>
                            <option v-for='data in row4.options' :value='data.id' :key="data.id + data.name">{{ data.name
                                }}</option>
                        </select>
                    </b-input-group>
                </div>
                <div v-else>
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select :name="row4.label" class='form-control' v-model='search_by_filter[row4.label]'>
                            <option value=''>Select {{ stringView(row4.label) }}</option>
                            <option v-for='data in row4.options' :value='data.name' :key="data.id">{{ data.name }}
                            </option>
                        </select>
                    </b-input-group>
                </div>
            </div>
        </div>



        <!-- <div class="mt-4">
            <b-button class="filter_btn" v-b-toggle.sidebar_right variant="outline-secondary" block title="Set Filter">
                <div>Set Filter</div>
            </b-button>
            <b-button class="filter_btn" variant="outline-secondary" block title="Clear Filter" @click="resetFlter();">
                <div>Clear Filter</div>
            </b-button>
        </div> -->

        <div class="mt-4 row">
            <div class="col-6">
                <b-button class="filter_btn" v-b-toggle.sidebar_right variant="primary" block title="Set Filter">
                    <div>Set Filter</div>
                </b-button>
            </div>

            <div class="col-6">
                <b-button class="filter_btn" variant="primary" block title="Clear Filter" @click="resetFlter();">
                    <div>Clear Filter</div>
                </b-button>
            </div>

        </div>
    </div>
</template>


<script>
export default {
    props: ['company_options', 'search_by_filter', 'column_selected', 'default_column', 'leave_type_options'],

    data() {



        //columns.forEach((column) => {sortOrders[column.name] = -1;});
        return {
            leave_type_arr: [],
            filter_by_id: ['jobposition', 'department', 'branch', 'leave_policy', 'leave_type'],
            filter_by_id_options: [{ jobposition: "jobposition_id" }, { department: "department_id" }, { branch: "branch_id" }, { leave_policy: "leave_policy_id" }, { leave_type: "leave_type_id" }],
        }
    },
    methods: {

        generateFilterOptions: function () {

            for (const [key, value] of Object.entries(this.leave_type_options)) {
                for (const [key2, value2] of Object.entries(value)) {
                    if (this.leave_type_arr[key]) {
                        this.leave_type_arr[key].push(value2.leave_type_id);
                    } else {
                        this.leave_type_arr[key] = [];
                        this.leave_type_arr[key].push(value2.leave_type_id);
                    }

                }
            }

            let value = [];
            value['reset'] = 0;
            value['search_by_filter'] = this.search_by_filter;

            this.$emit('childToParent', value);

        },
        stringView(str) {
            var i, frags = str.split('_');
            for (i = 0; i < frags.length; i++) {
                frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            return frags.join(' ');
        },
        resetFlter: function () {
            let value = [];
            value['reset'] = 1;
            let cr = this.search_by_filter;
            let defaultval = {};
            Object.keys(this.search_by_filter).forEach(key => {

                defaultval[key] = '';
            });
            value['search_by_filter'] = defaultval;
            this.$emit('childToParent', value);
        },
        setFlter: function () {
            let value = [];
            value['toggle'] = 1;
            this.$emit('childToParent', value);
        },
    },
    created: function () {
        this.generateFilterOptions();
    }


}
</script>
<style>
.btn.filter_btn.btn-outline-secondary.btn-block {
    width: 49%;
    display: inline-block;
    vertical-align: top;
    margin-top: 0;
}
</style>
